import { defineMessages } from 'react-intl';

export default defineMessages({
  attribute_name: {
    id: 'importType.attribute_name.title',
    defaultMessage: 'Attribute name'
  },
  attribute_value: {
    id: 'importType.attribute_value.title',
    defaultMessage: 'Attribute value'
  },
  brand: {
    id: 'importType.brand.title',
    defaultMessage: 'Brand'
  },
  classification: {
    id: 'importType.classification.title',
    defaultMessage: 'Classification'
  },
  contact: {
    id: 'importType.contact.title',
    defaultMessage: 'Contact'
  },
  customer: {
    id: 'importType.customer.title',
    defaultMessage: 'Customer'
  },
  employee: {
    id: 'importType.employee.title',
    defaultMessage: 'Employee'
  },
  facet: {
    id: 'importType.facet.title',
    defaultMessage: 'Facet'
  },
  group_type: {
    id: 'importType.group_type.title',
    defaultMessage: 'Group Type'
  },
  inventory_adjustment: {
    id: 'importType.inventory_adjustment.title',
    defaultMessage: 'Inventory Adjustment'
  },
  inventory_transfer: {
    id: 'importType.inventory_transfer.title',
    defaultMessage: 'Inventory Transfer'
  },
  item_location: {
    id: 'importType.item_location.title',
    defaultMessage: 'Item - Location'
  },
  item: {
    id: 'importType.item.title',
    defaultMessage: 'Item'
  },
  location: {
    id: 'importType.location.title',
    defaultMessage: 'Location'
  },
  loyalty_movement: {
    id: 'importType.loyalty_movement.title',
    defaultMessage: 'Loyalty Movement'
  },
  payment: {
    id: 'importType.payment.title',
    defaultMessage: 'Payment'
  },
  price_book: {
    id: 'importType.pricebook.title',
    defaultMessage: 'Price Book'
  },
  region: {
    id: 'importType.region.title',
    defaultMessage: 'Region'
  },
  sale_transaction: {
    id: 'importType.sale_transaction.title',
    defaultMessage: 'Sale Transaction'
  },
  season: {
    id: 'importType.season.title',
    defaultMessage: 'Season'
  },
  subsidiary: {
    id: 'importType.subsidary.title',
    defaultMessage: 'Subsidiary'
  },
  entity_address: {
    id: 'importType.entity_address.title',
    defaultMessage: 'Entity Address'
  },
  location_address: {
    id: 'importType.location_address.title',
    defaultMessage: 'Location Address'
  },
  subsidiary_address: {
    id: 'importType.subsidiary_address.title',
    defaultMessage: 'Subsidiary Address'
  },
  supplier: {
    id: 'importType.supplier.title',
    defaultMessage: 'Supplier'
  },
  gift_certificate: {
    id: 'importType.gift_certificate.title',
    defaultMessage: 'Gift Certificate'
  },
  credit_note: {
    id: 'importType.credit_note.title',
    defaultMessage: 'Credit Note'
  },
  price_group: {
    id: 'importType.price_group.title',
    defaultMessage: 'Price Group'
  },
  item_group_price: {
    id: 'importType.item_group_price.title',
    defaultMessage: 'Item Group Price'
  },
  unit_of_measure_type: {
    id: 'importType.unit_of_measure_type.title',
    defaultMessage: 'UOM Type'
  },
  item_uom: {
    id: 'importType.item_uom.title',
    defaultMessage: 'Item UOM'
  },
  alternate_item_number: {
    id: 'importType.alternate_item_number.title',
    defaultMessage: 'Alternate Item Number'
  },
  item_reference_number: {
    id: 'importType.item_reference_number.title',
    defaultMessage: 'Item Reference Number'
  },
  list_item: {
    id: 'importType.list_item.title',
    defaultMessage: 'List Item'
  },
  device: {
    id: 'importType.device.title',
      defaultMessage: 'Device'
  },
});


// inventory_movement_control: {
//   id: 'importType.inventory_movement_control.title',
//     defaultMessage: 'Inventory Movement'
// }

// {
//   key: 'importType.item_inventory.title',
//     name: 'Item - Inventory',
//       value: 'item_inventory',
//         id: 'item_inventory'
// },
// {
//   key: 'importType.item_matrix.title',
//     name: 'Item - Matrix',
//       value: 'item_matrix',
//         id: 'item_matrix'
// },
// {
//   key: 'importType.item_batch.title',
//     name: 'Item - Batch',
//       value: 'item_batch',
//         id: 'item_batch'
// },
// {
//   key: 'importType.item_serialized.title',
//     name: 'Item - Serialized',
//       value: 'item_serialized',
//         id: 'item_serialized'
// },
// {
//   key: 'importType.item_bundle.title',
//     name: 'Item - Bundle',
//       value: 'item_bundle',
//         id: 'item_bundle'
// },
// {
//   key: 'importType.item_service.title',
//     name: 'Item - Service',
//       value: 'item_service',
//         id: 'item_service'
// },
// {
//   key: 'importType.item_non_inventory.title',
//     name: 'Item - Non-inventory',
//       value: 'item_non_inventory',
//         id: 'item_non_inventory'
// },

// address_type: {
//   id: 'importType.address_type.title',
//     defaultMessage: 'Address type'
// },
// cash_rounding: {
//   id: 'importType.cash_rounding.title',
//     defaultMessage: 'Cash rounding'
// },
// country: {
//   id: 'importType.country.title',
//     defaultMessage: 'Country'
// },
// credit_type: {
//   id: 'importType.credit_type.title',
//     defaultMessage: 'Credit type'
// },
// currency: {
//   id: 'importType.currency.title',
//     defaultMessage: 'Currency'
// },
// device_type: {
//   id: 'importType.device_type.title',
//     defaultMessage: 'Device type'
// },
// exchange_rate: {
//   id: 'importType.exchange_rate.title',
//     defaultMessage: 'Exchange rate'
// },
// hotkey_group: {
//   id: 'importType.hotkey_group.title',
//     defaultMessage: 'Hotkey group'
// },
// hotkey_group_item: {
//   id: 'importType.hotkey_group_item.title',
//     defaultMessage: 'Hotkey group item'
// },
// payment_type: {
//   id: 'importType.payment_type.title',
//     defaultMessage: 'Payment type'
// },
// price_level: {
//   id: 'importType.price_level.title',
//     defaultMessage: 'Price level'
// },
// promotion: {
//   id: 'importType.promotion.title',
//     defaultMessage: 'Promotion'
// },
// reason_code: {
//   id: 'importType.reason_code.title',
//     defaultMessage: 'Reason code'
// },
// related_entity_type: {
//   id: 'importType.related_entity_type.title',
//     defaultMessage: 'Relationship type'
// },
// shift_type: {
//   id: 'importType.shift_type.title',
//     defaultMessage: 'Shift type'
// },
// supplier: {
//   id: 'importType.supplier.title',
//     defaultMessage: 'Supplier'
// },
// task: {
//   id: 'importType.task.title',
//     defaultMessage: 'Task'
// },
// task_type: {
//   id: 'importType.task_type.title',
//     defaultMessage: 'Task type'
// },
// tax_code: {
//   id: 'importType.tax_code.title',
//     defaultMessage: 'Tax code'
// },
// tax_group: {
//   id: 'importType.tax_group.title',
//     defaultMessage: 'Tax group'
// },
// tax_type: {
//   id: 'importType.tax_type.title',
//     defaultMessage: 'Tax type'
// },
// item_matrix_attribute: {
//   id: 'importType.item_matrix_attribute.title',
//     defaultMessage: 'Item - Matrix definition'
// },
// purchase_order: {
//   id: 'importType.purchase_order.title',
//     defaultMessage: 'Purchase Order'
// },
